import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';

export type GuestLoginPayload = { username: string; envKey: string; client: string };

export interface ILoginGuestUseCase {
    execute(url: string, payload: GuestLoginPayload): Promise<unknown | null>;
}

export class LoginGuestUseCase implements ILoginGuestUseCase {
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    async execute(url: string, payload: GuestLoginPayload): Promise<unknown | null> {
        return this.authRepo.loginGuest(url, payload);
    }
}
